// @flow

import React, { PureComponent } from "react";
import type { Dispatch } from "redux";

import { openDialog } from "../../../base/dialog";
import { IconUserGroups } from "../../../base/icons";
import { Label } from "../../../base/label";
import { COLORS } from "../../../base/label/constants";
import { getParticipantCount } from "../../../base/participants";
import { connect } from "../../../base/redux";
import { SpeakerStats } from "../../../speaker-stats";
import { openSettingsDialog, SETTINGS_TABS } from "../../../settings";

/**
 * The type of the React {@code Component} props of {@link ParticipantsCount}.
 */
type Props = {
    /**
     * Number of the conference participants.
     */
    count: number,

    /**
     * Conference data.
     */
    conference: Object,
    /**
     * The moderator check by ahmad.
     */
    _isModeratorCheckAhmad: Object,

    /**
    /**
     * Invoked to open Speaker stats.
     */
    dispatch: Dispatch<any>,
};

/**
 * ParticipantsCount react component.
 * Displays the number of participants and opens Speaker stats on click.
 *
 * @class ParticipantsCount
 */
class ParticipantsCount extends PureComponent<Props> {
    /**
     * Initializes a new ParticipantsCount instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);
        const val = sessionStorage.getItem("isModerator");

        this.state = {
            isModLogin: val == "true" ? true : false,
        };
        this._onClick = this._onClick.bind(this);
    }

    _onClick: () => void;

    /**
     * Callback invoked to display {@code SpeakerStats}.
     *
     * @private
     * @returns {void}
     */
    _onClick() {
        const { dispatch, conference } = this.props;

        dispatch(openDialog(SpeakerStats, { conference }));
    }

    /**
     * Implements React's {@link PureComponent#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    // componentDidUpdate(prevProps) {
    //     const { _isModeratorCheckAhmad } = this.props;

    //     // Compare previous _isModeratorCheckAhmad with current _isModeratorCheckAhmad
    //     if (
    //         _isModeratorCheckAhmad?.isModerators?.value !==
    //         prevProps._isModeratorCheckAhmad?.isModerators?.value
    //     ) {
    //         // React to changes in _isModeratorCheckAhmad
    //         if (_isModeratorCheckAhmad.isModerators.value) {
    //             // console.log("Moderator added");
    //             sessionStorage.removeItem("participantIsUser");

    //             this.setState({
    //                 isModLogin: true,
    //             });
    //         } else {
    //             // React to the case where the value becomes false
    //             console.log("Moderator removed");
    //             // Perform any other necessary actions
    //         }
    //     }
    // }
    render() {
        const { count, dispatch } = this.props;
        console.log("countParticpant", count, this.state.isModLogin);
        // let isModLogin = JSON.parse(localStorage.getItem("isModerator"))
        //     ? true
        //     : false;

        if (count < 2) {
            return this.state.isModLogin ? (
                ""
            ) : (
                <div
                    style={{
                        zIndex: 2,
                        position: "absolute",
                        textAlign: "center",
                        color: "white",
                        fontSize: "1.4rem",
                        top: "5rem",
                        cursor: "pointer",
                        padding: 20,
                        borderRadius: 10,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <span
                        id="waitingAdviser"
                        style={{
                            textShadow: "3px 3px 3px black",
                        }}
                    >
                        Votre Rendez-vous Visio Orange : merci de patienter
                        jusqu’à l’arrivée de votre conseiller boutique.
                    </span>
                    <span
                        onClick={() =>
                            dispatch(openSettingsDialog(SETTINGS_TABS.DEVICES))
                        }
                        style={{
                            fontSize: "1.1rem",
                            textDecoration: "underline",
                            marginTop: "20px",
                            textShadow: "3px 3px 3px black",
                        }}
                    >
                        Testez et réglez votre audio et vidéo …
                    </span>
                </div>
            );
        }

        // if (count <= 2) {
        //     return null;
        // }
        if (count <= 2) {
            return null;
        } else {
            return (
                <Label
                    color={COLORS.white}
                    icon={IconUserGroups}
                    onClick={this._onClick}
                    text={count}
                />
            );
        }
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code ParticipantsCount} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    return {
        conference: state["features/base/conference"].conference,
        count: getParticipantCount(state),
        _isModeratorCheckAhmad: state["features/base/participants"],
    };
}

export default connect(mapStateToProps)(ParticipantsCount);
